
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'ConsentReceiveMailings',
  props: {
    consentMailing: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    }
  },
  emits: ['closeConsentMailing']
})
